<template>
  <div class="drivers-occupancy-course-selection px-4 pb-4">
    <div class="d-flex align-center py-2" style="gap: 8px;">
      <v-btn icon small :disabled="isSendingCourses" @click="backFromCourseSelection">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <div>
        <div class="text-subtitle-1 font-weight-medium">
          Wyślij wybrane kursy
        </div>
        <div v-if="selectedDriverName" class="text-caption text--secondary">
          Kierowca: {{ selectedDriverName }}
        </div>
      </div>
    </div>

    <v-form
      ref="sendCoursesForm"
      v-model="isFormValid"
      class="custom-form"
      style="max-width: 1100px;"
      @submit.prevent="send"
    >
      <v-row dense class="mt-2">
        <v-col cols="12" class="mb-4">
          <div class="text-caption text--secondary mb-1">
            Kursy do wysłania
          </div>
          <div v-if="isSwapLeaveCourse" class="text-body-2">
            Wymiana: {{ selectedLeaveCourseSummary }}
          </div>
          <template v-else>
            <div v-if="selectedLeaveCourseSummary" class="text-body-2">
              Podstawienie: {{ selectedLeaveCourseSummary }}
            </div>
            <div v-if="selectedPickupCourseSummary" class="text-body-2">
              Zabranie: {{ selectedPickupCourseSummary }}
            </div>
          </template>
        </v-col>

        <v-col cols="12">
          <DateWithTimePicker
            v-if="isDueDateSet"
            :date-with-time="dueDate"
            default-time="05:30"
            label="Data realizacji"
            :keep-time="true"
            @changeTime="dueDate = $event"
          />
        </v-col>

        <v-col cols="12">
          <v-autocomplete
            v-model="receiverData"
            :items="departmentsList"
            validate-on-blur
            item-text="name"
            :rules="[rules.required]"
            label="Dane przyjmującego"
            placeholder="Wybierz oddział"
            outlined
            dense
            :disabled="isSendingCourses"
          />
        </v-col>

        <v-col cols="12" class="d-flex justify-end pt-2">
          <v-btn color="primary" type="submit" :loading="isSendingCourses" :disabled="isSendingCourses">
            Wyślij kursy
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import DateTime from 'luxon/src/datetime'
import DateWithTimePicker from '../Forms/Inputs/DateWithTime'
import rules from '../../utils/validators'

const formatCourseSummary = course => {
  if (!course) return ''
  const parts = [course.orderRefNumber, course.clientName].filter(Boolean)
  return parts.join(' · ') || `ID ${course.courseId}`
}

export default {
  components: {
    DateWithTimePicker
  },
  data() {
    return {
      rules,
      dueDate: DateTime.now().toISO(),
      receiverData: '',
      isDueDateSet: false,
      isFormValid: true
    }
  },
  computed: {
    ...mapState({
      selectedDriver: state => state.driversOccupancy.selectedDriver,
      selectedLeaveCourse: state => state.driversOccupancy.selectedLeaveCourse,
      selectedPickupCourse: state => state.driversOccupancy.selectedPickupCourse,
      departmentsList: state => state.departments.items,
      department: state => state.core.department,
      isSendingCourses: state => state.driversOccupancy.isSendingCourses
    }),
    ...mapGetters({
      isSwapLeaveCourse: 'driversOccupancy/isSwapLeaveCourse'
    }),
    selectedDriverName() {
      if (!this.selectedDriver) return ''
      return (
        this.selectedDriver.name ||
        `${this.selectedDriver.firstName || ''} ${this.selectedDriver.lastName || ''}`.trim()
      )
    },
    selectedLeaveCourseSummary() {
      return formatCourseSummary(this.selectedLeaveCourse)
    },
    selectedPickupCourseSummary() {
      return formatCourseSummary(this.selectedPickupCourse)
    }
  },
  mounted() {
    this.receiverData = this.department?.name || ''
    this.isDueDateSet = true
  },
  methods: {
    ...mapActions({
      backFromCourseSelection: 'driversOccupancy/backFromCourseSelection',
      sendSelectedCourses: 'driversOccupancy/sendSelectedCourses'
    }),
    async send() {
      const isValid = await this.$refs.sendCoursesForm.validate()
      if (!isValid) return

      await this.sendSelectedCourses({
        dueDate: this.dueDate,
        receiverData: this.receiverData
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.drivers-occupancy-course-selection {
  min-height: 360px;
}
</style>
